import { ErrorStateMatcher } from '@angular/material/core';
import { FormGroupDirective, NgForm, UntypedFormControl } from '@angular/forms';

export class ErrorMatcher implements ErrorStateMatcher {
    isErrorState(control: UntypedFormControl | null, form: FormGroupDirective | NgForm | null): boolean {
      const isSubmitted = form && form.submitted;
      return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
    }
  }